import { render, staticRenderFns } from "./RTE.vue?vue&type=template&id=2e443c60&scoped=true"
import script from "./RTE.vue?vue&type=script&setup=true&lang=js"
export * from "./RTE.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e443c60",
  null
  
)

export default component.exports